// @flow
import { connect } from 'react-redux';

import CardSimple from 'components/fragments/card/CardSimple';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/fragments/card/CardSimple';

export default connect(
  (state: StateType): StateProps => ({
    userPref: state.userState.userPref
  })
)(CardSimple);
